'use strict';

angular.module('mediacloudApp')
    .controller('ZoomInstallController', function ($rootScope, $scope, $location, $window, $state, $timeout, Auth, Principal, SchedulerService, Tenant) {
        if(!Principal.isAuthenticated()){
            // Tenant Info
            Tenant.info().then(function (data) {
                if(data) {
                    if(data.samlEnabled){
                        window.location.href = './saml/login';
                    }
                    else{
                        $state.go('login');
                    }
                }
            });
        }
        else{
            sessionStorage.removeItem('zoomRedirect');
            SchedulerService.OAuth.get({standaloneInstall: true}, function(response){
                window.location.href = response.requestUrl
            });
        }
    });
